<template>
    <ItemMenuWrapper v-slot="{ inputId }" :label="label">
        <InputText :modelValue="modelValue" :id="inputId" @update:modelValue="handleUpdate" />
    </ItemMenuWrapper>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { defineEmits, defineProps } from 'vue';

defineProps({
    label: {
        type: String,
    },
    modelValue: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['update:modelValue']);
const handleUpdate = (value) => {
    emit('update:modelValue', value);
};
</script>
